import { v4 as uuidv4 } from 'uuid';
import { IHeaderRequest } from '../EGerdauService/types';
import { CookiesKey } from './enum';
import { getValueCookie } from './utils';
import { EGerdauService } from '../EGerdauService';

export const buildAuthHeaders = ({
  withCommerceToken = false
}: {
  withCommerceToken?: boolean;
} = {}): IHeaderRequest => {
  const token = getValueCookie(CookiesKey.ACCESS_TOKEN);
  const client_id = process.env.REACT_APP_oauthClientID as string;
  const client_secret = process.env.REACT_APP_oauthClientSecret as string;
  const ssoAccess = getValueCookie(CookiesKey.SSO_ACCESS);
  const authorization_token = getValueCookie(CookiesKey.AUTHORIZATION_TOKEN);
  const profile_access_token = getValueCookie(CookiesKey.PROFILE_ACCESS_TOKEN);
  const current_correlation_id = getValueCookie(CookiesKey.CORRELATION_ID);
  const commerce_token = getValueCookie(CookiesKey.COMMERCE_TOKEN) ?? ''; //Adobe token GR-600

  const correlation_id =
    current_correlation_id ?? EGerdauService.setCorrelationId(uuidv4());

  return {
    Authorization: `Bearer ${authorization_token}`,
    client_id,
    client_secret,
    sso_access: `${ssoAccess}`,
    'Profile-Access-Token': `Bearer ${profile_access_token ?? token}`,
    'x-correlation-id': `${correlation_id}`,
    'x-related-path': EGerdauService.getRelatedPath(),
    ...(!!commerce_token &&
      withCommerceToken && {
        'x-commerce-token': `Bearer ${commerce_token}`
      })
  };
};

export const useAuth = () => ({
  getHeaders: buildAuthHeaders
});
